export const SEX_OPTIONS = [
  { value: 0, label: "Женский" },
  { value: 1, label: "Мужской" }
];

export const STRANA_OPTIONS = [
  { value: 0, label: "Россия" },
  { value: 1, label: "СНГ" },
  { value: 2, label: "Вне СНГ" }
];

export const pick = (row, ...keys) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
  }
  return undefined;
};

export const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const toFlag = (value) => Number(value) === 1;

export const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

export const normalizeListRow = (row) => ({
  idPred: toNumber(pick(row, "idPred", "IdPred")),
  vid: toNumber(pick(row, "vid", "Vid")) ?? 0,
  vidName: pick(row, "vidName", "VidName") ?? "",
  name: pick(row, "name", "Name") ?? "",
  dateBird: pick(row, "dateBird", "DateBird") ?? null,
  phone: pick(row, "phone", "Phone") ?? "",
  city: pick(row, "city", "City") ?? "",
  email: pick(row, "email", "Email") ?? "",
  smsAgree: toFlag(pick(row, "smsAgree", "SmsAgree"))
});

export const normalizeCard = (row) => ({
  idPred: toNumber(pick(row, "idPred", "IdPred")),
  vid: toNumber(pick(row, "vid", "Vid")) ?? 0,
  name: pick(row, "name", "Name") ?? "",
  adress: pick(row, "adress", "Adress") ?? "",
  adressFact: pick(row, "adressFact", "AdressFact") ?? "",
  inn: pick(row, "inn", "Inn") ?? "",
  city: pick(row, "city", "City") ?? "",
  phone: pick(row, "phone", "Phone") ?? "",
  email: pick(row, "email", "Email") ?? "",
  komment: pick(row, "komment", "Komment") ?? "",
  region: toNumber(pick(row, "region", "Region")) ?? 0,
  portalId: pick(row, "portalId", "PortalId") ?? "",
  dateReg: pick(row, "dateReg", "DateReg") ?? null,
  smsAgree: toFlag(pick(row, "smsAgree", "SmsAgree")),
  rs: pick(row, "rs", "Rs") ?? "",
  ks: pick(row, "ks", "Ks") ?? "",
  bik: pick(row, "bik", "Bik") ?? "",
  bank: pick(row, "bank", "Bank") ?? "",
  okpo: pick(row, "okpo", "Okpo") ?? "",
  ogrn: pick(row, "ogrn", "Ogrn") ?? "",
  okato: pick(row, "okato", "Okato") ?? "",
  dateBird: pick(row, "dateBird", "DateBird") ?? null,
  pasport: pick(row, "pasport", "Pasport") ?? "",
  passportCode: pick(row, "passportCode", "PassportCode") ?? "",
  sex: toNumber(pick(row, "sex", "Sex")) ?? 0,
  idSg: toNumber(pick(row, "idSg", "IdSg")) ?? 0,
  idStrana: toNumber(pick(row, "idStrana", "IdStrana")) ?? 0,
  workPlace: pick(row, "workPlace", "WorkPlace") ?? "",
  workPosition: pick(row, "workPosition", "WorkPosition") ?? "",
  prcExp: toNumber(pick(row, "prcExp", "PrcExp")),
  director: pick(row, "director", "Director") ?? "",
  buhgalter: pick(row, "buhgalter", "Buhgalter") ?? ""
});

export const emptyCard = () => ({
  idPred: null,
  vid: 0,
  name: "",
  adress: "",
  adressFact: "",
  inn: "",
  city: "",
  phone: "",
  email: "",
  komment: "",
  region: 0,
  portalId: "",
  dateReg: new Date().toISOString(),
  smsAgree: false,
  rs: "",
  ks: "",
  bik: "",
  bank: "",
  okpo: "",
  ogrn: "",
  okato: "",
  dateBird: null,
  pasport: "",
  passportCode: "",
  sex: 0,
  idSg: 0,
  idStrana: 0,
  workPlace: "",
  workPosition: "",
  prcExp: null,
  director: "",
  buhgalter: ""
});

export const normalizeLookups = (data) => {
  const mapItems = (arr) =>
    (Array.isArray(arr) ? arr : [])
      .map((row) => ({
        value: toNumber(pick(row, "id", "Id")),
        label: pick(row, "name", "Name") ?? ""
      }))
      .filter((o) => o.value != null);

  return {
    vids: mapItems(pick(data, "vids", "Vids")),
    regions: [{ value: 0, label: "—" }, ...mapItems(pick(data, "regions", "Regions"))],
    socialGroups: [{ value: 0, label: "—" }, ...mapItems(pick(data, "socialGroups", "SocialGroups"))]
  };
};
